import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import { LoginCallback } from '@okta/okta-react';
import axios from 'axios';
import { oktaAuth } from '../../services/AuthService';
import { useDispatch } from 'react-redux';
import { loginAction } from '../../store/actions/AuthActions';
import { useOktaAuth } from '@okta/okta-react';
 
const CustomLoginCallback = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const [userInfo, setUserInfo] = useState(null);
    useEffect(() => {
        const handleLogin = async () => {
            try {
                // Wait for Okta to handle the redirect callback
                await oktaAuth.handleLoginRedirect()
                // Get the tokens from Okta's token manager
                const accessToken = await oktaAuth.tokenManager.get('accessToken');
                const idToken = await oktaAuth.tokenManager.get('idToken');
                oktaAuth.getUser().then((info)=>{
                    setUserInfo(info)
              
                if (!accessToken || !idToken) {
                    throw new Error('Tokens not found');
                }
                dispatch(loginAction(true,undefined,undefined,info,navigate))
                });
            } catch (error) {
                console.error('Okta login failed:', error);
                navigate('/login'); // Redirect to login page on error
            } finally {
                setLoading(false);
            }
        };

        handleLogin();
    }, [navigate]);

    return (
        <div>
            {loading ? <p>Loading...</p> : <p>Processing...</p>}
        </div>
    );
};

export default CustomLoginCallback;
